import api from './utils/axios';
import { TagSpecResponse } from '@/types/tag';

export class CommonService {
  private readonly META_PREFIX = 'meta';

  /**
   * Fetches all content types
   * @returns Promise containing the content types data
   */
  async getContentTypes() {
    try {
      const response = await api.get(`${this.META_PREFIX}/content-types/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching content types:', error);
      throw error;
    }
  }

  /**
   * Fetches tag specifications
   * @returns Promise containing the tag specs data
   */
  async getTagSpecs(): Promise<TagSpecResponse> {
    try {
      const response = await api.get(`/tag-specs/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching tag specs:', error);
      throw error;
    }
  }

  /**
   * Fetches all enums
   * @returns Promise containing the enums data
   */
  async getEnums() {
    try {
      const response = await api.get(`${this.META_PREFIX}/enums/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching enums:', error);
      throw error;
    }
  }

  /**
   * Fetches enum values by name
   * @param name The name of the enum to fetch
   * @returns Promise containing the specific enum data
   */
  async getEnumByName(name: string) {
    try {
      const response = await api.get(`${this.META_PREFIX}/enums/${name}/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching enum ${name}:`, error);
      throw error;
    }
  }

  /**
   * Fetches access keys
   * @returns Promise containing the access keys data
   */
  async getAccessKeys() {
    try {
      const response = await api.get(`settings/access-keys/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching access keys:', error);
      throw error;
    }
  }
}

export default new CommonService();
